<template>
  <emd-button
    type="text"
    color="primary"
    v-bind="$attrs"
    @click="$emit('click')"
  >
    <slot />
  </emd-button>
</template>
<script>
import { EmdButton } from 'emerald-vue/src/components'
export default {
  name: 'CancelButton',
  components: {
    EmdButton
  }
}
</script>
